import { useQuery } from 'react-query';
import request from '../../../../helpers/request';

const key = (addressId) => ['clients-permit', addressId];

const getClientsByAddress = async (addressId) => {
  return request.get(
    `/HousingStock/address/${addressId}/clients`,
    {},
    'При получении клиентов произошла ошибка'
  );
};

const useClientsByAddressQuery = (addressId, options) =>
  useQuery(key(addressId), () => getClientsByAddress(addressId), options);

export default useClientsByAddressQuery;
